module.exports = __webpack_public_path__ + "static/media/AutoSegmentationTool.1531e769.png";